module.exports = __webpack_public_path__ + "res/32-img_bg_l.7e8810557bf83b81aecb006fc4db4c28.png";